import {
  GET_USER_LIST_SUCCESSFULLY,
  GET_USER_LIST_FAILED,
  GET_GROUP_LIST_SUCCESSFULLY,
  GET_GROUP_LIST_FAILED,
  GET_FRANCHISE_LIST_SUCCESSFULLY,
  GET_FRANCHISE_LIST_FAILED,
  ADD_USER_SUCCESSFULLY,
  ADD_USER_FAILED,
  UPDATE_USER_SUCCESSFULLY,
  UPDATE_USER_FAILED,
  DELETE_USER_SUCCESSFULLY,
  DELETE_USER_FAILED,
  GET_USERS_DETAIL_FAILED,
  GET_USERS_DETAIL_SUCCESSFULLY,
  ADD_GROUP_SUCCESSFULLY,
  ADD_GROUP_FAILED,
  GET_GROUP_DETAILS_SUCCESSFULLY,
  GET_GROUP_DETAILS_FAILED,
  DELETE_GROUP_SUCCESSFULLY,
  DELETE_GROUP_FAILED,
  UPDATE_GROUP_SUCCESSFULLY,
  UPDATE_GROUP_FAILED,
  GET_USER_ROLES_SUCCESSFULLY,
  GET_USER_ROLES_FAILED,
} from "../types";
import axiosInstance from "../../Lib/axios";

//Add User
export const addUser = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/staff-user/`, params, {})
      .then((response) => {
        dispatch({
          type: ADD_USER_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            if (error.response.status === 500) {
              dispatch({
                type: ADD_USER_FAILED,
                data: ["500: Something Went Wrong"],
              });
            } else {
              dispatch({
                type: ADD_USER_FAILED,
                data: error.response.data,
              });
            }
          }
        }
      });
  };
};

// get user of detail
export const getUserEditDetail = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/staff-user/${params}/`)
      .then((response) => {
        dispatch({
          type: GET_USERS_DETAIL_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_USERS_DETAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// update User Details
export const updateEditedUSer = (params, id) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/crm/staff-user/${id}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_USER_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          } else {
            if (error.response.status === 500) {
              dispatch({
                type: UPDATE_USER_FAILED,
                data: ["500: Something Went Wrong"],
              });
            } else {
              dispatch({
                type: UPDATE_USER_FAILED,
                data: error.response.data,
              });
            }
          }
        }
      });
  };
};

//Get User List
export const getUserList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/staff-user/`, { params })
      .then((response) => {
        dispatch({
          type: GET_USER_LIST_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_USER_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Delete User
export const deleteUser = (params) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/crm/staff-user/${params}/`, {})
      .then(() => {
        dispatch({
          type: DELETE_USER_SUCCESSFULLY,
          data: { message: "deleted" },
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_USER_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get Group List
export const getGroupList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/user-group/`, { params })
      .then((response) => {
        dispatch({
          type: GET_GROUP_LIST_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_GROUP_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get Franchise list
export const getFranchiseList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`field-office/`, { params })
      .then((response) => {
        dispatch({
          type: GET_FRANCHISE_LIST_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_FRANCHISE_LIST_FAILED,
              data: error.response.data,
            });
          }
        }else {
          dispatch({
            type: GET_FRANCHISE_LIST_FAILED,
            data: error.message,
          });

        }
      });
  };
};

//Add Group
export const addNewGroup = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/user-group/`, params, {})
      .then((response) => {
        dispatch({
          type: ADD_GROUP_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: ADD_GROUP_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Get Group Details
export const getGroupDetails = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/user-group/${params}/`)
      .then((response) => {
        dispatch({
          type: GET_GROUP_DETAILS_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_GROUP_DETAILS_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// update Group Details
export const updateEditeGroup = (params, id) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`/crm/user-group/${id}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_GROUP_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          } else {
            dispatch({
              type: UPDATE_GROUP_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Delete User
export const deleteGroup = (params) => {
  return (dispatch) => {
    return axiosInstance
      .delete(`/crm/user-group/${params}/`, {})
      .then(() => {
        dispatch({
          type: DELETE_GROUP_SUCCESSFULLY,
          data: { message: "deleted" },
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: DELETE_GROUP_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

export const getRoles = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/role/`, { params })
      .then((response) => {
        dispatch({
          type: GET_USER_ROLES_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign("/");
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_USER_ROLES_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};
